import {
  REMOVE_NOTIFICATION,
  SET_NOTIFICATIONS,
  RESET_NOTIFICATIONS
} from "../../actions/notifications/notificationsAction";

const initialState = {
  policies: [],
  selectedPolicy: null
};

const getSelectedPolicy = (policies, membershipNumber) => {
  return policies.find(m => m.membershipNumber === membershipNumber);
};

export default function notificationsReducer(state = initialState, action) {
  let copiedState = { ...state };

  if (action.type === SET_NOTIFICATIONS) {
    copiedState.policies = [...copiedState.policies];
    const membershipNumber = action.payload.membershipNumber;
    copiedState.selectedPolicy = getSelectedPolicy(
      copiedState.policies,
      membershipNumber
    );

    if (!copiedState.selectedPolicy) {
      copiedState.policies.push({ ...action.payload });
    } else {
      let policyIndex = copiedState.policies.findIndex(
        p => p.membershipNumber === copiedState.selectedPolicy.membershipNumber
      );
      copiedState.policies[policyIndex] = action.payload;
    }
    copiedState.selectedPolicy = getSelectedPolicy(
      copiedState.policies,
      membershipNumber
    );
  } else if (action.type === REMOVE_NOTIFICATION) {
    copiedState.policies = [...copiedState.policies];
    let copyOfSelectedPolicy = {
      ...getSelectedPolicy(
        copiedState.policies,
        copiedState.selectedPolicy.membershipNumber
      )
    };
    copyOfSelectedPolicy.notifications = [
      ...copyOfSelectedPolicy.notifications
    ];

    let index = copyOfSelectedPolicy.notifications.findIndex(
      n => n.SecurityId === action.payload
    );
    copyOfSelectedPolicy.notifications.splice(index, 1);

    let policyIndex = copiedState.policies.findIndex(
      p => p.membershipNumber === copyOfSelectedPolicy.membershipNumber
    );
    copiedState.policies[policyIndex] = copyOfSelectedPolicy;
    copiedState.selectedPolicy = copyOfSelectedPolicy;
  } else if (action.type === RESET_NOTIFICATIONS) {
    copiedState.policies = [];
    copiedState.selectedPolicy = null;
  }
  return copiedState;
}
